import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';


export const enum CopyStatus {
    NORMAL, SUCCESS, ERROR
}

@Component({
    selector: 'hbr-copy-input',
    template: `<div>
    <div class="command-title" *ngIf="!iconMode">
        {{headerTitle}}
    </div>
    <div>
        <span  [class.hide]="iconMode">
            <input type="text" class="command-input" size="{{inputSize}}" [(ngModel)]="defaultValue" #inputTarget readonly/>
        </span>
        <span>
            <input type="text" size="{{inputSize}}" [(ngModel)]="defaultValue" #inputTarget1 style="width: 1px; min-width: 0px; padding: 0; opacity: .1;">
        </span>
        <span>
            <clr-icon shape="copy" [class.is-success]="isCopied" [class.is-error]="hasCopyError" class="info-tips-icon" size="24" [ngxClipboard]="inputTarget1" (cbOnSuccess)="onSuccess($event)" (cbOnError)="onError($event)"></clr-icon>
        </span>
    </div>
</div>`,
    styles: [`.commands-container{min-width:360px;max-width:720px;padding-left:24px}.h5-override{display:inline-block!important;margin-top:0!important;margin-bottom:12px}.commands-section{margin-top:12px;margin-bottom:24px}.info-tips-icon{color:grey}.info-tips-icon:hover{color:#007cbb;cursor:pointer}.command-title{font-size:14px;padding-left:6px}.command-input{font-size:14px;font-weight:500}:host>>>.dropdown-menu{min-width:360px;max-width:720px}.btn-font{font-size:14px!important}.hide{display:none}`],

    providers: []
})

export class CopyInputComponent implements OnInit {
    @Input() inputSize: number = 40;
    @Input() headerTitle: string = "Copy Input";
    @Input() defaultValue: string = "N/A";
    @Input() iconMode: boolean = false;

    state: CopyStatus = CopyStatus.NORMAL;

    @Output() onCopySuccess: EventEmitter<any> = new EventEmitter<any>();
    @Output() onCopyError: EventEmitter<any> = new EventEmitter<any>();

    ngOnInit(): void { }
    onSuccess($event: any): void {
        this.state = CopyStatus.SUCCESS;
        this.onCopySuccess.emit($event);
    }

    onError(error: any): void {
        this.state = CopyStatus.ERROR;
        this.onCopyError.emit(error);
    }

    reset(): void {
        this.state = CopyStatus.NORMAL;
    }

    setPullCommendShow(): void {
        this.iconMode = false;
    }

    public get isCopied(): boolean {
        return this.state === CopyStatus.SUCCESS;
    }

    public get hasCopyError(): boolean {
        return this.state === CopyStatus.ERROR;
    }
}
